import styled, { css } from 'styled-components'
import { SearchableList } from '@popety-io/ui'

export const StyledSearchableList = styled(SearchableList)``

export const FilterContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
`

export const FilterPill = styled.button<{ $active: boolean }>`
  padding: 6px 12px;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  color: #6b6b6b;
  white-space: nowrap;
  font-family: inherit;

  &:hover {
    background: #f5f5f5;
    border-color: #999;
  }

  ${({ $active }) =>
    $active &&
    css`
      background: #e6f7fc;
      border-color: #00ade6;
      color: #00ade6;
    `}
`

export const DateGroup = styled.div`
  margin-bottom: 24px;
  margin-top: 24px;
`

export const DateLabel = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  padding-left: 16px;

  &:not(:first-child) {
    margin-top: 24px;
  }
`

export const ActivityItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  /* Highlight search matches */
  mark {
    background: #ffeb3b;
    color: #1a1a1a;
    font-weight: 500;
    border-radius: 2px;
  }
`

export const ActivityIcon = styled.div<{ $type: 'create' | 'delete' }>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 2;
  }

  ${({ $type }) =>
    $type === 'create'
      ? css`
          background: rgba(0, 179, 65, 0.1);
          color: #00994d;
        `
      : css`
          background: rgba(255, 59, 48, 0.1);
          color: #ff3366;
        `}
`

export const ActivityContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const ActivityAction = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 4px;

  strong {
    font-weight: 600;
  }
`

export const ActivityDetails = styled.div`
  font-size: 12px;
  color: #6b6b6b;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActivityTimestamp = styled.div`
  font-size: 11px;
  color: #999;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
`

export const EmptyIcon = styled.div`
  color: #999;
  margin: 0 auto 16px;
  width: 48px;
  height: 48px;
`

export const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 8px;
`

export const EmptyDescription = styled.div`
  font-size: 13px;
  color: #6b6b6b;
`
